var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 13.8444,
    cy: 10.8452,
    r: 1.31202
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 18.218,
    cy: 10.8452,
    r: 1.31202
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 13.8444,
    cy: 14.7808,
    r: 1.31202
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 18.218,
    cy: 14.7808,
    r: 1.31202
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 13.8444,
    cy: 18.7183,
    r: 1.31202
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 18.218,
    cy: 18.7183,
    r: 1.31202
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2728 6C10.0176 6 9.00008 7.01753 9.00008 8.27273V21.2897C9.00008 22.5449 10.0176 23.5625 11.2728 23.5625H12.5324V23.9138C12.5324 24.6669 13.1429 25.2774 13.896 25.2774H18.1662C18.9193 25.2774 19.5298 24.6669 19.5298 23.9138V23.5625H20.7911C22.0463 23.5625 23.0638 22.5449 23.0638 21.2897V8.27273C23.0638 7.01753 22.0463 6 20.7911 6H11.2728ZM10.8183 8.27273C10.8183 8.02169 11.0218 7.81818 11.2728 7.81818H20.7911C21.0421 7.81818 21.2456 8.02169 21.2456 8.27273V21.2897C21.2456 21.5408 21.0421 21.7443 20.7911 21.7443H11.2728C11.0218 21.7443 10.8183 21.5408 10.8183 21.2897V8.27273Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/KIOSK.37592c67.svg";
export { ForwardRef as ReactComponent };